const inputTextLimit = 250;
const inputDescLimit = 10000;
const editProfileLimit = 25;

export { inputTextLimit, inputDescLimit, editProfileLimit }